import { httpClient } from 'shared/api/http-client'

export const regenerateJWT = () => httpClient.post('/api/user/token/regenerate')
